module.exports = __webpack_public_path__ + "img/unipi.c73bf956.png";